var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgParticulates = function SvgParticulates(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.33 7a3.25 3.25 0 1 1-3.25-3.3A3.25 3.25 0 0 1 10.33 7ZM2.5 0a2 2 0 1 0 2 2 2 2 0 0 0-2-2ZM1.25 6.88A1.25 1.25 0 1 0 2.5 8.13a1.25 1.25 0 0 0-1.25-1.25Zm2.1 3.45a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5Zm4.4 1.17A1.25 1.25 0 1 0 9 12.75a1.25 1.25 0 0 0-1.25-1.25Zm4.5-3A1.75 1.75 0 1 0 14 10.25a1.75 1.75 0 0 0-1.75-1.75Zm-.08-6.25a1.25 1.25 0 1 0 1.25 1.25 1.25 1.25 0 0 0-1.25-1.25Z"
  })));
};

export default SvgParticulates;